<template>
  <component :is="animationComponent" v-if="activeHoliday && animationComponent && shouldShowAnimation" />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue'

import { useUIStore } from '~/stores/useUIStore'

const uiStore = useUIStore()
const { $holiday } = useNuxtApp()

const holidayAnimation = computed(() => uiStore.holidayAnimation)

const activeHoliday = computed(() => ($holiday as any)?.getActive())

const shouldShowAnimation = computed(() => {
  return activeHoliday.value?.animation?.enabled && holidayAnimation.value
})

const animationComponent = computed(() => {
  if (!activeHoliday.value?.animation?.component) {
    return null
  }

  const holidayId = activeHoliday.value.id

  try {
    return defineAsyncComponent(() => import(`@/components/holiday/${holidayId}/Animation.vue`))
  } catch (error) {
    console.warn(`Holiday animation component not found for: ${holidayId}`, error)
    return null
  }
})
</script>
